// extracted by mini-css-extract-plugin
export default {"pageContainer":"sales_pageContainer__uuFQj"};